var _a;
import { AssessmentRisk } from 'src/constants/assessments';
import { riskLevels } from 'src/constants/ehrNoteEnums';
import { riskLevelRender } from 'src/constants/riskLevel';
export var groupedKinds = {
    PHQ: ['PHQ9', 'PHQ2'],
    GAD: ['GAD7', 'GAD2'],
};
export var isGroupedKind = function (kind) {
    return Object.values(groupedKinds).some(function (group) { return group.includes(kind); });
};
export var keyForGroupedKind = function (kind) {
    var _a;
    var key = (_a = Object.entries(groupedKinds).find(function (_a) {
        var group = _a[1];
        return group.includes(kind);
    })) === null || _a === void 0 ? void 0 : _a[0];
    if (!key) {
        // Should always be protected by isGroupedKind to prevent this
        throw new Error('Invalid key');
    }
    return key;
};
export var assessmentRiskRender = (_a = {},
    _a[AssessmentRisk.low] = riskLevelRender[riskLevels.low],
    _a[AssessmentRisk.lowMedium] = {
        color: 'red.500',
        emphasis: 'medium-emphasis',
        colorScheme: 'info',
    },
    _a[AssessmentRisk.medium] = riskLevelRender[riskLevels.medium],
    _a[AssessmentRisk.high] = riskLevelRender[riskLevels.high],
    _a);
export var abbreviationsForGroupedKind = function (kind, questionnaireKinds) {
    var group = groupedKinds[kind];
    return group
        .map(function (groupedKind) { var _a; return (_a = questionnaireKinds.find(function (qk) { return qk.label === groupedKind; })) === null || _a === void 0 ? void 0 : _a.abbreviation; })
        .join(', ');
};
